import { Component, Input, Output, EventEmitter } from '@angular/core';
export interface FeatureData {
  img: string;
  title: string;
  subtitle: string;
  description: string;
  modal?: any;
  externalLink: string;
}

export interface FeaturesData {
  title: string;
  subtitle: string;
  data: Array<FeatureData>;
  buttons: Array<{ title: string; color: string }>;
}

@Component({
  selector: 'fcp-showcase-features',
  templateUrl: './showcase-features.component.html',
  styleUrls: ['./showcase-features.component.scss']
})
export class ShowcaseFeaturesComponent {
  @Input() public features: FeaturesData = null;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public emitClick(feature: FeatureData): void {
    if (feature.externalLink) {
      window.open(feature.externalLink);
      return;
    }

    if (feature.modal && feature.modal.length > 0) {
      this.wasClicked.emit(feature.modal);
    }
  }

  scrollToElementEmitClick($element): void {
    if ($element.button.target) {
      this.wasClickedScrollToElement.emit($element.button.target);
    }
  }
}
